export function parseStVersion(input) {
    if (input == null) {
        return null
    }
    if (typeof input === 'object' && input.major != null) {
        return {
            major: input.major,
            minor: input.minor,
            build: input.build
        }
    }
    const versionString = typeof input === 'object' ? input.st : input
    const [major, minor, build] = versionString.split('.').map(Number)
    return { major, minor, build }
}

export function isStVersionAtLeast(actual, minimum) {
    if (actual.major !== minimum.major) {
        return actual.major > minimum.major
    }
    if (actual.minor !== minimum.minor) {
        return actual.minor > minimum.minor
    }
    return actual.build >= minimum.build
}

export function isStVersionAtMost(actual, maximum) {
    if (actual.major !== maximum.major) {
        return actual.major < maximum.major
    }
    if (actual.minor !== maximum.minor) {
        return actual.minor < maximum.minor
    }
    return actual.build <= maximum.build
}

export function stVersionMet(stVersion, minVersion, maxVersion) {
    if (!minVersion) {
        return true
    }
    const actual = parseStVersion(stVersion)
    const minimum = parseStVersion(minVersion)
    if (!isStVersionAtLeast(actual, minimum)) {
        return false
    }
    if (maxVersion == null) {
        return true
    }
    const maximum = parseStVersion(maxVersion)
    return isStVersionAtMost(actual, maximum)
}
